import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./pages/auth/login/login.component";
import { SmsSendComponent } from "./pages/auth/sms-send/sms-send.component";
import { MainPageComponent } from "./pages/main-page/main-page.component";
import { RecoveryPasswordComponent } from "./pages/auth/recovery-password/recovery-password.component";
import { RequestComponent } from "./pages/auth/recovery-password/request/request.component";
import { RequestSendComponent } from "./pages/auth/recovery-password/request-send/request-send.component";
import { ResetPasswordComponent } from "./pages/auth/reset-password/reset-password.component";
import { UpdatePasswordComponent } from "./pages/auth/reset-password/update-password/update-password.component";
import { ResetSuccessComponent } from "./pages/auth/reset-password/reset-success/reset-success.component";
import { RegisterComponent } from "./pages/auth/register/register.component";
import { PersonalDataComponent } from "./pages/auth/register/personal-data/personal-data.component";
import { ProductsComponent } from "./pages/auth/register/products/products.component";
import { AgreementComponent } from "./pages/auth/register/agreement/agreement.component";
import { AgreementPageComponent } from "./pages/agreement/agreement-page.component";
import { RegisterSuccessComponent } from "./pages/auth/register/register-success/register-success.component";
import { CompanyDataComponent } from "./pages/auth/register/company-data/company-data.component";
import { AddressCompanyComponent } from "./pages/auth/register/address-company/address-company.component";
import { AnalyticsComponent } from "./pages/analytics/analytics.component";
import { UserListComponent } from "./pages/user-list/user-list.component";
import { NotificationsComponent } from "./pages/notifications/notifications.component";
import { RoleListComponent } from "./pages/role-list/role-list.component";
import { RecurringPaymentListComponent } from "./pages/recurring-payment-list/recurring-payment-list.component";
import { PaymentListComponent } from "./pages/payment-list/payment-list.component";
import { ReturnListComponent } from "./pages/return-list/return-list.component";
import { InformationComponent } from "./pages/information/information.component";
import { SavedCardListComponent } from "./pages/saved-card-list/saved-card-list.component";
import { TerminalListComponent } from "./pages/terminal-list/terminal-list.component";
import { VirtualCashListComponent } from "./pages/virtual-cash-list/virtual-cash-list.component";
import { PaymentLinkListComponent } from "./pages/payment-link-list/payment-link-list.component";
import { PaymentToCardComponent } from "./pages/payment-to-card/payment-to-card.component";
import { authGuard } from "./security/auth.guard";
import { PaymentViewListComponent } from "./pages/payment-view-list/payment-view-list.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { SupportComponent } from "./pages/support/support.component";
import { permissionGuard } from "./security/permission.guard";

const routes: Routes = [
	{
		path: "login",
		component: LoginComponent,
		data: {
			headerHide: true,
		},
	},
	{
		path: "sms-code",
		component: SmsSendComponent,
		data: {
			headerHide: true,
		},
	},
	{
		path: "recovery-password",
		component: RecoveryPasswordComponent,
		children: [
			{
				path: "request",
				component: RequestComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "request-send",
				component: RequestSendComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "",
				redirectTo: "request",
				pathMatch: "full",
			},
		],
	},
	{
		path: "reset-password",
		component: ResetPasswordComponent,
		children: [
			{
				path: "update",
				component: UpdatePasswordComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "success",
				component: ResetSuccessComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "",
				redirectTo: "update",
				pathMatch: "full",
			},
		],
	},
	{
		path: "register",
		component: RegisterComponent,
		children: [
			{
				path: "personal-data",
				component: PersonalDataComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "company-data",
				component: CompanyDataComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "address-company",
				component: AddressCompanyComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "products",
				component: ProductsComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "agreement",
				component: AgreementComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "success",
				component: RegisterSuccessComponent,
				data: {
					headerHide: true,
				},
			},
			{
				path: "",
				redirectTo: "personal-data",
				pathMatch: "full",
			},
		],
	},
	{
		path: "agreement",
		component: AgreementPageComponent,
		data: {
			headerHide: true,
		},
	},
	{
		path: "main-page",
		component: MainPageComponent,
	},
	{
		path: "analytics",
		component: AnalyticsComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "ANALYTICS",
		},
	},
	{
		path: "user-list",
		component: UserListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "USERS",
		},
	},
	{
		path: "role-list",
		component: RoleListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "ROLES",
		},
	},
	{
		path: "payment-list",
		component: PaymentListComponent,
		canActivate: [authGuard, permissionGuard],
		data: {
			titlePage: "PAYMENTS",
			permission: "PAYMENT_VIEW",
		},
	},
	{
		path: "recurrent-payment-list",
		component: RecurringPaymentListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "RECURRENT_PAYMENTS",
		},
	},
	{
		path: "return-list",
		component: ReturnListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "RETURN",
		},
	},
	{
		path: "information",
		component: InformationComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "INFO",
		},
	},
	{
		path: "saved-card-list",
		component: SavedCardListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "SAVE_CARDS",
		},
	},
	{
		path: "terminal-list",
		component: TerminalListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "TERMINALS",
		},
	},
	{
		path: "virtual-cash-list",
		component: VirtualCashListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "VIRTUAL",
		},
	},
	{
		path: "payment-view-list",
		component: PaymentViewListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "PAYMENT_VIEW",
		},
	},
	{
		path: "payment-links",
		component: PaymentLinkListComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "PAYMENT_LINKS",
		},
	},
	{
		path: "payment-to-card",
		component: PaymentToCardComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "PAYMENT_CARD",
		},
	},
	{
		path: "notification",
		component: NotificationsComponent,
		canActivate: [authGuard],
		data: {
			titlePage: "NOTIFICATION",
		},
	},
	{
		path: "profile",
		component: ProfileComponent,
		// canActivate: [authGuard],
		data: {
			titlePage: "PROFILE",
		},
	},
	{
		path: "support",
		component: SupportComponent,
		// canActivate: [authGuard],
		data: {
			titlePage: "SUPPORT",
		},
	},
	{ path: "**", redirectTo: "login" },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
